import { render, staticRenderFns } from "./categorieActions.vue?vue&type=template&id=188424ae"
import script from "./categorieActions.vue?vue&type=script&lang=js"
export * from "./categorieActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports